import { ImageType } from "@core/types";

export const getPreviewImage = (image?: ImageType) => {
  if (!image) return undefined;

  return image.previewSrc
    ? {
        src: image.previewSrc,
        type: image.type,
      }
    : image;
};
